export interface CreateRepDTO {
  firstName: string;
  lastName: string;
  mobile: string;
  phone: string;
  title: string;
  email?: string;
  client: { id: string };
  notes: string;
}

export interface updateRepDTO {
  firstName: string;
  lastName: string;
  mobile: string;
  phone: string;
  title: string;
  email: string;
  client: string;
  notes: string;
}

export interface FormProps {
  label: string;
  value: string | { id: string };
  type: string;
  placeholder: string;
  name: string;
}

export class CreateRepFormData {
  [key: string]: FormProps;

  firstName = {
    label: 'First Name *',
    value: '',
    type: 'text',
    placeholder: 'Enter first name',
    name: 'firstName'
  };

  lastName = {
    label: 'Last Name *',
    value: '',
    type: 'text',
    placeholder: 'Enter last name',
    name: 'lastName'
  };

  mobile = {
    label: 'Mobile *',
    value: '',
    type: 'tel',
    placeholder: 'Enter mobile number',
    name: 'mobile'
  };

  phone = {
    label: 'Phone',
    value: '',
    type: 'tel',
    placeholder: 'Enter phone number',
    name: 'phone'
  };

  title = {
    label: 'Title',
    value: '',
    type: 'text',
    placeholder: 'Enter title',
    name: 'title'
  };

  email = {
    label: 'Email',
    value: '',
    type: 'email',
    placeholder: 'Enter email',
    name: 'email'
  };

  client = {
    label: 'Company *',
    value: { id: '' },
    type: 'select',
    placeholder: 'Select company',
    name: 'client'
  };

  notes = {
    label: 'Notes',
    value: '',
    type: 'textarea',
    placeholder: 'Enter notes',
    name: 'notes'
  };
}
